import { useNavigate } from 'react-router-dom';
import { createClient } from '@supabase/supabase-js';

const supabase = createClient(
  import.meta.env.VITE_PUBLIC_SUPABASE_URL,
  import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY
);

export default function Features() {
  const navigate = useNavigate();

  const handleFeatureClick = async (link: string) => {
    // Kullanıcının giriş yapıp yapmadığını kontrol et
    const { data: { user } } = await supabase.auth.getUser();
    
    if (!user) {
      // Giriş yapmamışsa login sayfasına yönlendir
      navigate('/auth/login');
    } else {
      // Giriş yapmışsa ilgili sayfaya git
      navigate(link);
    }
  };

  const features = [
    {
      icon: 'ri-book-2-line',
      title: 'Ders Notları',
      description: 'Tüm konular için detaylı ve anlaşılır ders notları. İstediğin zaman, istediğin yerden erişim sağla.',
      color: 'from-teal-500 to-cyan-500',
      image: 'https://public.readdy.ai/ai/img_res/d29792910ac3564470415573892d2118.jpg',
      link: '/notes'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Özet Bilgiler',
      description: 'Sınav öncesi hızlı tekrar için hazırlanmış özet bilgiler ve formül kartları.',
      color: 'from-emerald-500 to-green-500',
      image: 'https://readdy.ai/api/search-image?query=Colorful%20summary%20cards%20and%20flashcards%20with%20science%20formulas%2C%20quick%20reference%20sheets%20spread%20on%20modern%20desk%2C%20organized%20study%20materials%20with%20sticky%20notes%2C%20bright%20clean%20background%20with%20teal%20highlights%2C%20top%20view%20flat%20lay%20photography&width=600&height=400&seq=feature-002&orientation=landscape',
      link: '/dashboard'
    },
    {
      icon: 'ri-file-edit-line',
      title: 'Online Deneme',
      description: 'Gerçek sınav formatında online denemeler. Anında sonuç ve detaylı çözüm analizleri.',
      color: 'from-cyan-500 to-blue-500',
      image: 'https://readdy.ai/api/search-image?query=Student%20taking%20online%20exam%20on%20laptop%20computer%2C%20modern%20digital%20test%20interface%20with%20multiple%20choice%20questions%2C%20clean%20workspace%20with%20study%20lamp%2C%20focused%20learning%20environment%20with%20teal%20and%20white%20color%20scheme%2C%20professional%20educational%20photography&width=600&height=400&seq=feature-003&orientation=landscape',
      link: '/online-exams'
    },
    {
      icon: 'ri-task-line',
      title: 'Ödev Takibi',
      description: 'Ödevlerini takip et, teslim tarihlerini kaçırma. Veliler de ilerlemeyi kolayca izleyebilir.',
      color: 'from-teal-500 to-emerald-500',
      image: 'https://readdy.ai/api/search-image?query=Digital%20homework%20tracking%20dashboard%20on%20tablet%20showing%20completed%20tasks%20with%20checkmarks%2C%20progress%20bars%20and%20calendar%20view%2C%20organized%20student%20planner%20interface%2C%20clean%20modern%20design%20with%20teal%20accents%2C%20bright%20educational%20workspace&width=600&height=400&seq=feature-004&orientation=landscape',
      link: '/homework-tracking'
    },
    {
      icon: 'ri-robot-2-line',
      title: 'AI Değerlendirme',
      description: 'Yapay zeka ile kişiselleştirilmiş değerlendirme. Eksik kazanımların için özel sorular.',
      color: 'from-purple-500 to-pink-500',
      image: 'https://readdy.ai/api/search-image?query=Artificial%20intelligence%20analyzing%20student%20performance%20with%20holographic%20data%20visualization%2C%20futuristic%20AI%20brain%20with%20neural%20networks%2C%20educational%20technology%20concept%20with%20glowing%20teal%20and%20purple%20lights%2C%20modern%20digital%20learning%20analytics&width=600&height=400&seq=feature-005&orientation=landscape',
      link: '/ai-evaluation'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'LGS Hedef Takibi',
      description: 'Deneme sonuçlarına göre LGS tahmini. Hedef lisene ulaşmak için gereken performans analizi.',
      color: 'from-orange-500 to-red-500',
      image: 'https://readdy.ai/api/search-image?query=Educational%20progress%20chart%20showing%20upward%20growth%20trend%2C%20colorful%20graphs%20and%20statistics%20on%20computer%20screen%2C%20goal%20tracking%20dashboard%20with%20achievement%20metrics%2C%20motivational%20study%20analytics%20with%20teal%20and%20orange%20colors%2C%20clean%20modern%20interface&width=600&height=400&seq=feature-006&orientation=landscape',
      link: '/lgs-tracking'
    },
  ];

  return (
    <section id="ozellikler" className="py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-100 rounded-full mb-6">
            <div className="w-2 h-2 bg-teal-500 rounded-full"></div>
            <span className="text-teal-700 text-sm font-semibold" style={{ fontFamily: 'Poppins, sans-serif' }}>
              ÖZELLİKLER
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Başarıya Giden Yolda
            <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-emerald-600">
              Yanındayız
            </span>
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" style={{ fontFamily: 'Poppins, sans-serif' }}>
            Modern eğitim teknolojileri ve yapay zeka desteği ile öğrenme deneyimini bir üst seviyeye taşıyoruz
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              onClick={() => handleFeatureClick(feature.link)}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 cursor-pointer"
            >
              {/* Image */}
              <div className="relative h-48 w-full overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className={`absolute inset-0 bg-gradient-to-br ${feature.color} opacity-20 group-hover:opacity-30 transition-opacity duration-300`}></div>
              </div>

              {/* Content */}
              <div className="p-6">
                <div className={`w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br ${feature.color} mb-4 group-hover:scale-110 transition-transform duration-300`}>
                  <i className={`${feature.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-teal-600 transition-colors duration-300" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {feature.title}
                </h3>
                <p className="text-gray-600 leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {feature.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
